<div class="clone-template-dialog">
    <h2 mat-dialog-title>
        Clonează Template
    </h2>

    <mat-dialog-content class="dialog-content">
        <!-- Template Preview Section -->
        <div class="preview-section mb-4" *ngIf="templatePreview">
            <h4 class="section-title">
                <i class="fas fa-eye me-2"></i>
                Previzualizare Template
            </h4>
            <div class="template-info bg-light p-3 rounded">
                <div class="row">
                    <div class="col-md-6">
                        <strong>ID:</strong> {{ templatePreview.id }}<br>
                        <strong>Nume:</strong> {{ data.templateName }}<br>
                        <strong>Tip:</strong> {{ templatePreview.type }}
                    </div>
                    <div class="col-md-6">
                        <div *ngIf="templatePreview.signatures_count !== undefined">
                            <strong>Semnături:</strong> {{ templatePreview.signatures_count }}<br>
                        </div>
                        <div *ngIf="templatePreview.parts_count !== undefined">
                            <strong>Părți:</strong> {{ templatePreview.parts_count }}<br>
                        </div>
                        <div *ngIf="templatePreview.categories_count !== undefined">
                            <strong>Categorii:</strong> {{ templatePreview.categories_count }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Clone Configuration Section -->
        <div class="clone-config-section">
            <h4 class="section-title">
                <i class="fas fa-cog me-2"></i>
                Configurație Clonare
            </h4>

            <!-- Clone Type Selection -->
            <div class="mb-3">
                <mat-form-field class="w-100">
                    <mat-label>Tip Clonare</mat-label>
                    <mat-select [(ngModel)]="cloneType" (selectionChange)="onCloneTypeChange()">
                        <mat-option value="document">Clonează ca Template Document</mat-option>
                        <mat-option value="smart_group" *ngIf="data.templateType === 'smart_group'">Clonează Grup Smart
                            Template</mat-option>
                        <mat-option value="smart_part">Convertește la Parte Smart Template</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- New Template Name -->
            <div class="mb-3">
                <mat-form-field class="w-100">
                    <mat-label>Numele Noului Template</mat-label>
                    <input matInput [(ngModel)]="newTemplateName" placeholder="Introduceți numele templateului clonat"
                        required>
                    <mat-error *ngIf="!newTemplateName">
                        Numele templateului este obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>

            <!-- Target Smart Group (for smart_part conversion) -->
            <div class="mb-3" *ngIf="cloneType === 'smart_part'">
                <mat-form-field class="w-100">
                    <mat-label>Grup Smart Template Destinație</mat-label>
                    <mat-select [(ngModel)]="targetGroupId" required>
                        <mat-option *ngFor="let group of availableGroups" [value]="group.id">
                            {{ group.name }} ({{ group.type }})
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="cloneType === 'smart_part' && !targetGroupId">
                        Selectați grupul destinație
                    </mat-error>
                </mat-form-field>
            </div>

            <!-- Part Description (for smart_part conversion) -->
            <div class="mb-3" *ngIf="cloneType === 'smart_part'">
                <mat-form-field class="w-100">
                    <mat-label>Descrierea Părții</mat-label>
                    <textarea matInput [(ngModel)]="partDescription" rows="3"
                        placeholder="Descrieți rolul acestei părți în documentul smart..."></textarea>
                </mat-form-field>
            </div>

            <!-- Cloning Options -->
            <div class="cloning-options mb-3">
                <h5 class="mb-2">Opțiuni Clonare:</h5>

                <div class="form-check mb-2" *ngIf="cloneType !== 'smart_part'">
                    <input class="form-check-input" type="checkbox" id="includeSignatures"
                        [(ngModel)]="includeSignatures">
                    <label class="form-check-label" for="includeSignatures">
                        Include semnăturile ({{ templatePreview?.signatures_count || 0 }})
                    </label>
                </div>

                <div class="form-check mb-2" *ngIf="cloneType !== 'smart_part'">
                    <input class="form-check-input" type="checkbox" id="includeCategories"
                        [(ngModel)]="includeCategories">
                    <label class="form-check-label" for="includeCategories">
                        Include categoriile ({{ templatePreview?.categories_count || 0 }})
                    </label>
                </div>

                <div class="form-check mb-2" *ngIf="cloneType === 'smart_group'">
                    <input class="form-check-input" type="checkbox" id="includeParts" [(ngModel)]="includeParts">
                    <label class="form-check-label" for="includeParts">
                        Include părțile template ({{ templatePreview?.parts_count || 0 }})
                    </label>
                </div>
            </div>
        </div>

        <!-- Progress Section (shown during cloning) -->
        <div class="progress-section" *ngIf="isCloning">
            <div class="d-flex align-items-center">
                <mat-spinner diameter="30" class="me-3"></mat-spinner>
                <span>Se clonează templateul...</span>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="onCancel()" [disabled]="isCloning">
            Anulează
        </button>
        <button mat-raised-button color="primary" (click)="onClone()" [disabled]="!isFormValid() || isCloning">
            <i class="fas fa-copy me-2"></i>
            Clonează
        </button>
    </mat-dialog-actions>
</div>